/**
 *
 * Component: Unauthorized
 * Date: 22/10/2020
 *
 */

import React from 'react';

import './style.css';
import { EmptyState } from 'components/common';

function Unauthorized() {
  return (
    <div className="unauthorized">
      <EmptyState message=" You are not authorized, mail us at support@prodigaltech.com to get access" />
    </div>
  );
}

export default Unauthorized;
